<div class="card" [class.disabled]="disabled()" test-id="card-wrapper">
  <h2 class="card-heading">{{ heading() | transloco }}</h2>
  <ng-content></ng-content>
</div>
